import { useIntl } from '@zenbusiness/application-commons-intl';
import PageError from '@zenbusiness/zui/PageError';

const UserBlocked = () => {
  const { formatMessage } = useIntl();
  const userBlockedDescription = (
    <>
      {formatMessage({ id: 'dashboard.callback.userBlocked1' })}
      <br />
      <br />
      {formatMessage({ id: 'dashboard.callback.userBlocked2' })}
      <br />
      <br />
      {formatMessage({ id: 'dashboard.callback.userBlocked3' })}
    </>
  );

  return (
    <PageError
      title={formatMessage({ id: 'dashboard.callback.userBlockedTitle' })}
      subtitle={userBlockedDescription}
    />
  );
};

UserBlocked.propTypes = {};

export default UserBlocked;
